import React from 'react';
import { Download, Loader2 } from 'lucide-react';

const DownloadPdfButton = ({ onClick, isDownloading = false, disabled = false }) => (
    <button
        type="button"
        onClick={onClick}
        disabled={isDownloading || disabled}
        className="flex items-center gap-2 px-4 py-2 border border-[#1F4B55] text-[#1F4B55] bg-white rounded-md text-sm font-semibold hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
    >
        {isDownloading ? <Loader2 size={18} className="animate-spin" /> : <Download size={18} />}
        {isDownloading ? 'Preparing PDF…' : 'Download PDF'}
    </button>
);

export default DownloadPdfButton;
